<script>
let className = '';

export { className as class };
export let required = false;
export let type = 'text';
export let title;
export let name;

function inputEvent(ev)
{
    if(type === 'number')
    {
        var el = ev.target;
        var pos = el.selectionStart;

        var reg = /[^\d,.]+/g;

        if(ev.data && String(ev.data).match(reg)) pos -= 1;

        // console.log(ev.data);

        el.value = el.value.replace(reg, '');

        el.selectionStart = el.selectionEnd = pos;
    }
}
</script>

<label class={"form-input " + className}>
    <div class="form-title">{title}{required ? "*" : ""}</div>
    <input {name} {required} on:input={inputEvent}/>
</label>

<style global lang="scss">
.form-input {
    @apply mb-8;

    &:not(:first-child) {
        @apply md:ml-5;
    }

    input {
        @apply w-full bg-transparent h-11 border-b text-lg border-white border-opacity-50 focus:text-primary focus:border-primary transition outline-none;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
}
</style>